"use client";
import { useEffect, useState } from "react";
import axios from "../../app/lib/axiosInstance";
import Image from "next/image";
import Link from "next/link";

const SimilarProducts = () => {
  const list = [
    {
      productName: "Product Name",
      img: "",
      brand: "BRAND",
      price: "32.00",
      offre: "30",
    },
    {
      productName: "Product Name",
      img: "",
      brand: "BRAND",
      price: "32.00",
      offre: "30",
    },
  ];

  // Get Similar Products
  const fetchSimilarProduct = async () => {
    const data = await axios
      .get(`/product/getsimilarproduct/672360ca39f83b3a89fa91a9`)
      .then((res) => res.data)
      .then((res) => {
        setIndex(
          [...Array(res.similarProducts.length).keys()]
            .map((i) => i)
            .slice(0, 4)
        );
        setArrayLength(res.similarProducts.length);
        setProducts(res.similarProducts);
      });
  };

  useEffect(() => {
    fetchSimilarProduct();
  }, []);

  const [index, setIndex] = useState([...Array(6 + 1).keys()].map((i) => i));
  const [arrayLength, setArrayLength] = useState();
  const [products, setProducts] = useState([]);

  const minus = () => {
    if (index[0] == 0) {
      setIndex(index);
    } else {
      setIndex(index.map((el) => el - 1));
    }
  };

  const plus = () => {
    if (index[3] == arrayLength - 1) {
      setIndex(index);
    } else {
      setIndex(index.map((el) => el + 1));
    }
  };

  return (
    <div className="flex flex-col my-8 gap-4 mx-4">
      <h2 className="text-[26px] font-semibold">Produits semblables</h2>

      <div className="flex justify-between items-center">
        <Image
          src="/icons/arrowLeft.png"
          width={500}
          height={500}
          className="w-[51px] h-[33px] cursor-pointer"
          onClick={minus}
        />
        <div className="flex w-[80%] justify-between">
          {index?.map((el, i) => {
            return (
              <Link href={`/product/${products[el]?.categories[0]}/${products[el]?._id}`} key={i}>
                <img src={products[el]?.image} width={100} height={100} />
                <div className="bg-[#CC0001] w-fit px-2  py-1 rounded-[7px] text-white text-[12px] font-medium">
                  {products[el]?.categories[0]}
                </div>
                <h2>{products[el]?.name}</h2>
                <h3>{products[el]?.brand}</h3>
                <div className="flex items-baseline mb-2">
                  {products[el]?.promo ? (
                    <h2 className="text-base text-[#C4C4C4] line-through">
                      {products[el]?.price} DT{" "}
                    </h2>
                  ) : null}
                  <h2 className="text-base">
                   
                    <span className="text-2xl">
                      {products[el]?.promo
                        ? products[el]?.price -
                          (products[el]?.price / 100) * products[el]?.promo
                        : products[el]?.price}DT{" "}
                    </span>
                  </h2>
                  {products[el]?.promo ? (
                    <div className="">
                      <h2 className="text-base border-[1px] border-[#000000] px-[14px] py-1 ml-4">
                        {products[el]?.promo}% Off
                      </h2>
                    </div>
                  ) : null}
                </div>
              </Link>
            );
          })}
        </div>
        <Image
          src="/icons/arrowRight.png"
          width={500}
          height={500}
          className="w-[51px] h-[33px] cursor-pointer"
          onClick={plus}
        />
      </div>
    </div>
  );
};

export default SimilarProducts;
